export default __webpack_public_path__ + "static/media/vg.a5c50c19.svg";